export const locale = {
    lang: 'en',
    data: {
        view: {
            resultsText: 'RESULTS',
            rowsText: 'Total Rows:',
            rowText: 'ROW',
            afterImportProcessResults: 'AFTER IMPORT PROCESS RESULTS'
        }
    }
};
